import Utils from 'general/utils/Utils';
import axiosClient from './axiosClient';

const driverApi = {
  // lay danh sach lai xe
  getDriverList: (params) => {
    const url = '/driver';
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  // lay thong tin lai xe
  getDriverDetail: (driverId) => {
    const url = `/driver/${driverId}`;
    return axiosClient.get(url);
  },

  // tao khach hang
  createDriver: (params) => {
    const url = '/driver/create';
    return axiosClient.post(url, params);
  },

  // cap nhat thong tin khach hang
  updateDriver: (driverId, params) => {
    const url = `/driver/${driverId}`;
    return axiosClient.put(url, params);
  },

  // xoa khach hang
  deleteDriver: (driverId) => {
    const url = `/driver/${driverId}`;
    return axiosClient.delete(url);
  },

  // lay lich su giao dich cua khach hang
  getDriverTransactionHistory: (driverId, params) => {
    const url = `/driver/${driverId}/transactions`;
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  // lay ds phien sac cua khach hang
  getDriverChargeSessions: (driverId, params) => {
    const url = `/driver/${driverId}/chargeSessions`;
    return axiosClient.get(url);
  },

  topUpDriverWallet : (driverId, params) => {
    const url = `/driver/topup`;
    return axiosClient.post(url, {
      driverId,
      ...params,
    });
  }
};

export default driverApi;
